export default `
  <h1>什么是日常活动消耗？</h1>
  <p>现实生活中，除来基础代谢，人体每天或多或少还会有一些活动或运动，也会消耗热量。</p>
  <p>日常活动消耗 是指人在从事日常工作、运动 和生活需要的能量。每个人日常活动不同，消耗也不同，取决于人体的活动水平，体力劳动者会比脑力劳动煮消耗更多的热量。</p>
`;
